import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useI18n} from '../../../../Utils/_helpers/useI18n'

interface SearchBarProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  isLoading?: boolean
}

export const SearchBar: React.FC<SearchBarProps> = ({value, onChange, isLoading}) => {
  const {t} = useI18n()

  return (
    <div className='d-flex align-items-center position-relative pt-2 ps-7'>
      {isLoading ? (
        <span className='position-absolute ms-6'>
          <span className='spinner-border spinner-border-sm text-primary' role='status' aria-hidden='true'></span>
        </span>
      ) : (
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6'
        />
      )}
      <input
        type='text'
        className='form-control form-control-solid w-250px ps-15'
        placeholder={t('PROMO_ACTION.SEARCH_PLACEHOLDER')}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}
